import { api } from './axios';
import { store } from '../../app/store';
import { refreshAccessToken } from './refreshToken';
import { setCredentials, logout } from '../../features/auth/authSlice';
import toast from 'react-hot-toast';

let isRefreshing = false;
let failedQueue = [];

const LOGOUT_ON_401_URLS = [
  "/v1/admin/personal/users",
  "/v1/admin/personal/manual-review-deposits",
  "/v1/admin/personal/manual-review-payouts",
  "/v1/admin/personal/pending-payouts",
];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
};

export const setupInterceptors = () => {
  api.interceptors.request.use(
    (config) => {
      const token = store.getState().auth.accessToken;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      console.log(token);
      return config;
    },
    (error) => Promise.reject(error)
  );

  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const requestUrl = originalRequest?.url;

      if (error.response?.status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
          // If a refresh is already in progress, add this request to the queue
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then(token => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              return api(originalRequest);
            })
            .catch(err => Promise.reject(err));
        }

        originalRequest._retry = true;
        isRefreshing = true;

     

        // try {
        //   const { accessToken, refreshToken } = await refreshAccessToken();
          
        //   // Update the store with the new tokens
        //   store.dispatch(setCredentials({ accessToken, refreshToken }));
        //   // store.dispatch(setCredentials({ 
        //   //   tokens: { accessToken, refreshToken } 
        //   // }));

        //   // Update authorization header
        //   originalRequest.headers.Authorization = `Bearer ${accessToken}`;
          
        //   // Process any requests that were waiting
        //   processQueue(null, accessToken);
          
        //   return api(originalRequest);
        // } catch (refreshError) {
        //   processQueue(refreshError, null);
        //   // Clear auth state and redirect to login
        //   // store.dispatch(logout());
        //   return Promise.reject(refreshError);
        // } finally {
        //   isRefreshing = false;
        // }
      }

      if (error.response?.status === 401) {
        const shouldLogout = LOGOUT_ON_401_URLS.some(url => requestUrl?.includes(url));
        
        if (shouldLogout) {
          store.dispatch(logout());
          toast.error("Session expired. Please login again.");
          return Promise.reject(error);
        }
      }

      // if (error?.response?.status === 401) {
      //   store.dispatch(logout());
      // }

      return Promise.reject(error);
    }
  );
};